export default __webpack_public_path__ + "static/lava-llama-nyc-screenshot-1e7a731f42236fb690bf1af96aaba15c.png";